import type {Module} from "vuex";
import type {RootState} from "@/store/types";

// Approval flow configuration delivered by the platform (see docs/approvals/*.json)
export type ApprovalConfig = Record<string, unknown>[]

export interface ConfigUserApprovalState {
    config: ApprovalConfig
}

const approval: Module<ConfigUserApprovalState, RootState> = {
    namespaced: true,
    state: {
        config: []
    },
    getters: {
        config: (state): ApprovalConfig => state.config
    },
    mutations: {
        setConfig: (state, config: ApprovalConfig) => state.config = config
    },
    actions: {
        setConfig(context, config: ApprovalConfig) {

            context.commit("setConfig", config);
        },
        clear(context) {

            context.commit("setConfig", []);
        }
    }
}

export default approval
